import { cn } from "@/lib/cn";

// 이름 이니셜 기반 색상 원형 아바타. 이름 해시로 결정론적 색상 배정.
const PALETTE = [
  { bg: "var(--primary-soft)", fg: "var(--primary)" },
  { bg: "var(--accent-soft)", fg: "var(--accent)" },
  { bg: "var(--ok-soft)", fg: "var(--ok)" },
  { bg: "var(--warn-soft)", fg: "var(--warn)" },
  { bg: "var(--danger-soft)", fg: "var(--danger)" },
];

function hash(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

const SIZE = {
  sm: "h-7 w-7 text-xs",
  md: "h-9 w-9 text-sm",
};

export function Avatar({
  name,
  size = "sm",
  className,
}: {
  name: string | null | undefined;
  size?: keyof typeof SIZE;
  className?: string;
}) {
  const label = name?.trim() || "·";
  const initial = label.charAt(0);
  const color = PALETTE[hash(label) % PALETTE.length];
  return (
    <span
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full font-semibold",
        SIZE[size],
        className
      )}
      style={{ background: color.bg, color: color.fg }}
      title={label}
    >
      {initial}
    </span>
  );
}
